/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isdisabled1Inputs */

const en_entity_isdisabled1 = /** @type {(inputs: Entity_Isdisabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Disabled`)
};

const de_entity_isdisabled1 = /** @type {(inputs: Entity_Isdisabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist deaktiviert`)
};

/**
* | output |
* | --- |
* | "Is Disabled" |
*
* @param {Entity_Isdisabled1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isdisabled1 = /** @type {((inputs?: Entity_Isdisabled1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isdisabled1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isdisabled1(inputs)
	return de_entity_isdisabled1(inputs)
});
export { entity_isdisabled1 as "entity_isDisabled" }